module.exports = __webpack_public_path__ + "static/media/cancel_view-pending-cancellations.071fc7d2.md";


//////////////////
// WEBPACK FOOTER
// ./src/docs/cancel_view-pending-cancellations.md
// module id = 1093
// module chunks = 0